import { render, staticRenderFns } from "./KeyChainProductSelect.vue?vue&type=template&id=3d5dc0ba&scoped=true&"
import script from "./KeyChainProductSelect.vue?vue&type=script&lang=js&"
export * from "./KeyChainProductSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5dc0ba",
  null
  
)

export default component.exports